import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=1326097b&scoped=true"
import script from "./MemberEdit.vue?vue&type=script&lang=js"
export * from "./MemberEdit.vue?vue&type=script&lang=js"
import style0 from "./MemberEdit.vue?vue&type=style&index=0&id=1326097b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326097b",
  null
  
)

export default component.exports